import styled from 'styled-components';
import { Box } from '@lemonade-hq/cdk';

const Container = styled(Box)`
  position: absolute;
  z-index: 1;
  background-color: black;
  border-radius: 50%;
  will-change: transform;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    left: -1500px;
  }
`;

export default function Giveback2020Finito({ ...props }) {
  return <Container {...props} />;
}
